import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { handleSnackBar } from "./global";
import MESSAGES from "../constants/messages";
// import { postAPICall } from '../utils/axios.util'
// import { nextAPIRoutes } from '../constants/apiRoutes'
import notificationService from "../services/notification.service";
// import authService from '../services/auth.service'

export const fetchNotifications = createAsyncThunk(
  "notifications/fetch",
  async ({ page }: { page: number }, { dispatch }) => {
    try {
      dispatch(setNotificationPage(page));
      dispatch(setLoadingNotifications(true));
      const resp: any = await notificationService.fetchNotifications({
        body: { page },
      });
      // postAPICall(nextAPIRoutes.GET_NOTIFICATIONS, {
      //   page,
      // })
      console.log("Notification res", resp);
      dispatch(setLoadingNotifications(false));
      return { data: resp?.data?.data ?? [], page };
    } catch (e: any) {
      console.log("Notification error", e);

      // if (e?.response?.data?.statusCode === 401) {
      //   authService.doLogoutWithRedirect()
      //   return
      // }
      dispatch(setLoadingNotifications(false));
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const markAsReadNotifications = createAsyncThunk(
  "notifications/read",
  async ({ id }: { id: number }, { dispatch }) => {
    try {
      await notificationService.markAsReadNotifications({ body: { id } });
      // await postAPICall(nextAPIRoutes.MARK_READ_NOTIFICATIONS, {
      //   id,
      // })
      return id;
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const markAllAsReadNotifications = createAsyncThunk(
  "notifications/readAll",
  async (_, { dispatch }) => {
    try {
      await notificationService.markAllAsReadNotifications({ body: {} });
      // await postAPICall(nextAPIRoutes.MARK_READALL_NOTIFICATIONS, {})
      return true;
    } catch (e: any) {
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

const notificationsSlice = createSlice({
  name: "notification",
  initialState: {
    page: 1,
    list: [] as Array<any>,
    listMeta: {},
    appNotifications: "0",
    loadingNotifications: false,
  },
  reducers: {
    setAppNotifications: (state, { payload }: { payload: string }) => {
      state.appNotifications = payload;
    },
    setLoadingNotifications: (state, { payload }: { payload: boolean }) => {
      state.loadingNotifications = payload;
    },
    setNotificationPage: (state, { payload }: { payload: number }) => {
      state.page = payload;
    },
    clearNotificationForUser: (state) => {
      state.list = [];
      state.listMeta = {};
      state.appNotifications = "0";
      state.page = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotifications.fulfilled, (state, { payload }: any) => {
        if (payload?.data?.list) {
          if (payload.page === 1) {
            state.list = payload?.data?.list;
          } else {
            state.list = state.list
              .concat(payload.data.list)
              .reduce((unique: any, o: any) => {
                if (!unique.some((obj: any) => obj.id === o.id)) {
                  unique.push(o);
                }
                return unique;
              }, []);
          }
          state.listMeta = payload.data.meta;
        } else {
          state.list = [];
          state.listMeta = {};
        }
      })
      .addCase(markAsReadNotifications.fulfilled, (state, { payload }) => {
        state.list = state.list.map((r) =>
          r.id === payload ? { ...r, is_seen: true } : r
        );
      })
      .addCase(markAllAsReadNotifications.fulfilled, (state) => {
        state.list = state.list.map((r) => ({ ...r, is_seen: true }));
      });
  },
});

export const {
  setAppNotifications,
  setLoadingNotifications,
  setNotificationPage,
  clearNotificationForUser,
} = notificationsSlice.actions;
export default notificationsSlice.reducer;
